"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var UriSchemaPortList = (function () {
    function UriSchemaPortList() {
    }
    UriSchemaPortList.getPort = function (schema) {
        return this[schema.toLowerCase()];
    };
    UriSchemaPortList.isDefaultPort = function (schema, port) {
        return this.getPort(schema) === port;
    };
    UriSchemaPortList.http = 80;
    UriSchemaPortList.https = 80;
    UriSchemaPortList.relative = undefined;
    return UriSchemaPortList;
}());
exports.UriSchemaPortList = UriSchemaPortList;

//# sourceMappingURL=uriSchemaPortList.js.map



//////////////////
// WEBPACK FOOTER
// ./node_modules/uribuilder/uriSchemaPortList.js
// module id = ./node_modules/uribuilder/uriSchemaPortList.js
// module chunks = vendor